import Button from "../../../../components/Button/Button";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import { WorkflowReportSettings } from "../../../../types/types";
import { ReportControlsProps } from "./ReportControls.types";

const ReportControls = (props: ReportControlsProps) => {

  const {
    showThermalHeatmapCheckbox,
    showMetalHeatmapCheckbox,
    showScanCommentsCheckbox,
    showVoiceNotesCheckbox,
    showScanImagesCheckbox,
    showTHzHeatmapCheckbox,
    isDownloadingReport,
    onGenerateReport
  } = props

  const generateReport = () => {
    const settings: WorkflowReportSettings = {
      include_heatmap_thz: showTHzHeatmapCheckbox.value,
      include_heatmap_ir: showThermalHeatmapCheckbox.value,
      include_heatmap_metal: showMetalHeatmapCheckbox.value,
      include_scan_comments: showScanCommentsCheckbox.value,
      include_voice_notes: showVoiceNotesCheckbox.value,
      include_images: showScanImagesCheckbox.value,
    }
    onGenerateReport(settings)
  }

  return (
    <>  
      <h2 className="analysis-control-title">Analysis</h2>

      <Checkbox 
        label="Include THz heatmap"
        checkbox={showTHzHeatmapCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include IR heatmap"
        checkbox={showThermalHeatmapCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include Metal heatmap"
        checkbox={showMetalHeatmapCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include scan comments"
        checkbox={showScanCommentsCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include voice notes"
        checkbox={showVoiceNotesCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include scan images"
        checkbox={showScanImagesCheckbox}
        isLoading={false}
      />

      <Button
        title="Download Report"
        onClick={generateReport}
        type="full"
        disabled={isDownloadingReport}
        isLoading={isDownloadingReport}
      />
    </>
  )
}

export default ReportControls